import appConfig from '../config/appConfig';

export const COUNTRIES = [
  'India',
  'United States',
  'United Kingdom',
  'Canada',
  'Australia',
  'United Arab Emirates',
  'Singapore',
  'Malaysia',
  'Germany',
  'France',
  'Japan',
  'China',
  'Sri Lanka',
  'Nepal',
  'Bangladesh',
  'Pakistan',
  'Other',
];

export const INDIAN_CITIES = [
  'Hyderabad',
  'Mumbai',
  'Delhi',
  'Bangalore',
  'Chennai',
  'Kolkata',
  'Pune',
  'Ahmedabad',
  'Jaipur',
  'Lucknow',
  'Chandigarh',
  'Kochi',
  'Visakhapatnam',
  'Nagpur',
  'Indore',
  'Bhopal',
  'Patna',
  'Surat',
  'Vadodara',
  'Coimbatore',
  'Thiruvananthapuram',
  'Guwahati',
  'Ranchi',
  'Raipur',
  'Bhubaneswar',
  'Dehradun',
  'Shimla',
  'Goa',
  'Agra',
  'Varanasi',
];

export const fetchLocationByPinCode = async (pinCode) => {
  try {
    const response = await fetch(`${appConfig.pincodeApiUrl}/${pinCode}`);
    const data = await response.json();

    if (data[0]?.Status === 'Success' && data[0]?.PostOffice?.length > 0) {
      const postOffice = data[0].PostOffice[0];
      return {
        city: postOffice.District || postOffice.Block || postOffice.Name || '',
        country: postOffice.Country || 'India',
      };
    }
    return null;
  } catch {
    return null;
  }
};
